module.exports = __webpack_public_path__ + "static/media/easter.d8eba540.jpg";